import { queryKeys } from "@l2a/shared";
import { FileText, LayoutTemplate, Send } from "lucide-react";
import { defineFeature } from "../types";

/**
 * PROPOSALS — quotes with package options the client chooses between, sent as a
 * login-free link and accepted online (PRD §8 Item 8, US-8.1…US-8.5).
 *
 * `/p/:token` is registered as a PUBLIC route: no shell, no session, no auth
 * redirect. The token is the authorisation and it carries its workspace inside
 * the signature, so the page needs nothing else.
 */
export default defineFeature({
  key: "proposals",
  title: "Proposals",
  entities: ["proposal"],
  routes: [
    { path: "proposals", lazy: () => import("./page") },
    // Static before dynamic: /proposals/templates must never be read as an id.
    { path: "proposals/templates", lazy: () => import("./templates") },
    { path: "proposals/:id", lazy: () => import("./detail") },
  ],
  publicRoutes: [{ path: "/p/:token", lazy: () => import("./public") }],
  nav: [
    {
      label: "Proposals",
      to: "/proposals",
      icon: FileText,
      group: "sales",
      order: 20,
      permission: "proposals:read",
      description: "Quotes clients accept online",
      badgeQueryKey: queryKeys.list("proposal", { status: "sent" }),
      badgeTone: "primary",
    },
  ],
  quickCreate: [
    {
      key: "proposals",
      label: "Proposal",
      icon: FileText,
      to: "/proposals?new=1",
      permission: "proposals:write",
      description: "Build a quote from a template",
    },
  ],
  commands: [
    {
      key: "proposals.awaiting",
      label: "Proposals waiting on a client",
      icon: Send,
      to: "/proposals?status=sent",
      group: "actions",
      permission: "proposals:read",
      keywords: ["quote", "pending", "sent"],
    },
    {
      key: "proposals.templates",
      label: "Proposal templates",
      icon: LayoutTemplate,
      to: "/proposals/templates",
      group: "navigate",
      permission: "proposals:read",
      keywords: ["quote template", "sections"],
    },
  ],
});
